import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../bookingConfirm/BookingConfirm.css'

const BookingConfirm = () => {
    const [selectedTermsConditionsType, setSelectedTermsConditionsType] = useState("TermsConditions");
    const [selectedCancellationType, setSelectedCancellationType] = useState("Cancellation");

  return (
    <div className='inner-booking-right-box'>
    <div className='booking-right-top'>
        <h2>Terms and Conditions</h2>
        <div className='terms-box'>
            <ul className='radio-box-checked d-flex align-items-center'>
                <li>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="TermsConditionsType" id="TermsConditions" value="TermsConditions" checked={selectedTermsConditionsType==="TermsConditions" } onChange={()=> setSelectedTermsConditionsType("TermsConditions")} />
                        <label className="form-check-label" htmlFor="TermsConditions">I have read and understood the Terms and Conditions.</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div className='booking-right-top mb-4'>
        <h2>Cancellation Policy</h2>
        <div className='terms-box'>
            <ul className='radio-box-checked d-flex align-items-center'>
                <li>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="CancellationType" id="Cancellation" value="Cancellation" checked={selectedCancellationType==="Cancellation" } onChange={()=> setSelectedCancellationType("Cancellation")} />
                        <label className="form-check-label" htmlFor="Cancellation">I have read and understood the Cancellation Policy. </label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div className='booking-bootm-box'>
        <div className='estimated-box'>
            <h2>Estimated Cost</h2>
            <ul className='table-layout-box'>
                <li className='d-flex flex-wrap justify-content-between'>
                    <span>Service</span>
                    <span>$45.00</span>
                </li>
                <li className='d-flex flex-wrap justify-content-between'>
                    <span>Add on</span>
                    <span>$45.00</span>
                </li>
                <li className='d-flex flex-wrap justify-content-between'>
                    <span>Travel fee</span>
                    <span>$3.50</span>
                </li>
            </ul>
            <ul className='total-out-put d-flex flex-wrap align-items-center justify-content-between'>
                <li>Total</li>
                <li className='text-color-pink'>$93.50</li>
            </ul>
            <Link rel='stylesheet' to='/add-service' className='btn btn-border btn-pink d-flex justify-content-center'>Confirm Request</Link>
        </div>
    </div>
</div>
  )
}

export default BookingConfirm